// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"367":"99639605","438":"6c9752ff","752":"e90d4870","795":"886097f6","799":"e1e65b7f","885":"e32ce087"}[chunkId] + ".chunk.css";
};